import { ImagePlus, Move, Palette, X } from "lucide-react";
import { useEffect } from "react";
import "./FrameHowItWorksModal.css";

export default function FrameHowItWorksModal({
  onClose,
  firstStepTitle = "Elige el color",
  firstStepText = "Prueba las opciones disponibles hasta encontrar tu favorita.",
}) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [onClose]);

  return (
    <div
      className="frame-help-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="frame-help-title"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="frame-help-modal__panel">
        <header className="frame-help-modal__header">
          <h2 id="frame-help-title">Como funciona</h2>
          <button type="button" onClick={onClose} aria-label="Cerrar">
            <X aria-hidden="true" />
          </button>
        </header>

        <div className="frame-help-modal__steps">
          <div className="frame-help-modal__step">
            <Palette aria-hidden="true" />
            <div>
              <strong>{firstStepTitle}</strong>
              <p>{firstStepText}</p>
            </div>
          </div>

          <div className="frame-help-modal__step">
            <ImagePlus aria-hidden="true" />
            <div>
              <strong>Sube tus fotos</strong>
              <p>Coloca una fotografia en cada hueco para ver el resultado.</p>
            </div>
          </div>

          <div className="frame-help-modal__step">
            <Move aria-hidden="true" />
            <div>
              <strong>Ajusta el encuadre</strong>
              <p>En movil, toca una foto para moverla, ampliarla o cambiarla.</p>
            </div>
          </div>
        </div>

        <p className="frame-help-modal__notice">
          Las fotografias son solo una vista previa. El marco se vende sin
          imanes personalizados.
        </p>

        <button
          type="button"
          className="frame-help-modal__confirm"
          onClick={onClose}
        >
          Entendido
        </button>
      </div>
    </div>
  );
}
